import React /* , { Component } */ from 'react';
import PropTypes from 'prop-types';

import TransitionGroup from 'react-transition-group/TransitionGroup';
import Transition from 'react-transition-group/CSSTransition';

import get from 'lodash/get';
import set from 'lodash/set';

import Newsletter from './newsletter';

function find(listId, subscribedToIds, condition) {
  let isFound;
  if (Array.isArray(listId)) {
    isFound = listId.reduce(
      (acc, curr) =>
        find(curr, subscribedToIds, condition) ||
        find(acc, subscribedToIds, condition)
    );

    return isFound;
  }
  if (condition) {
    isFound = subscribedToIds.indexOf(listId) !== -1;
  } else {
    isFound = subscribedToIds.indexOf(listId) === -1;
  }

  return isFound;
}

function NewsletterListSection(props) {
  const {
    subscribedToIds,
    sectionIds,
    masterLookup,
    state,
    handleChange,
    handleNewslettersRadioUpdate,
    alreadyUsed,
    sectionTitle,
    filter,
    transition
  } = props;

  const newsletters = sectionIds.map((listId, idx) => {
    if (filter) {
      if (alreadyUsed.hasOwnProperty(listId)) {
        return null;
      }
      const isFound = find(
        listId,
        subscribedToIds,
        sectionTitle === 'Your Current Subscriptions'
      );

      if (!isFound) {
        return null;
      }
    }
    const foundNewsletter = masterLookup[listId];
    set(alreadyUsed, listId, ''); // eslint-disable-line  no-param-reassign
    const name = get(foundNewsletter, 'listName');
    const desc = get(foundNewsletter, 'message');
    const choices = get(foundNewsletter, 'choices');
    const isRadio = get(foundNewsletter, 'radio', false);
    let lists = Array.isArray(listId) ? listId : [listId];
    let checked = Array.isArray(listId)
      ? listId.map(id => state[id])
      : [state[listId]];
    if (typeof listId === 'string' && listId.split(',').length) {
      lists = listId.split(',');
      checked = listId.split(',').map(id => state[id]);
    }
    const newsletter = (
      <Newsletter
        name={name}
        desc={desc}
        lists={lists}
        checked={checked}
        choices={choices}
        onChange={handleChange}
        key={`${listId}${idx}`}
        isRadio={isRadio}
        handleNewslettersRadioUpdate={handleNewslettersRadioUpdate}
      />
    );
    return transition ? (
      <Transition classNames="fade" key={`${listId}${idx}`} timeout={500}>
        {newsletter}
      </Transition>
    ) : (
      newsletter
    );
  });
  return (
    <div key={sectionTitle} className="newsletter-list-section">
      <h3 className="newsletter-list-section__label">{sectionTitle}</h3>
      {transition ? (
        <TransitionGroup className="newsletter-list-section__input-group">
          {newsletters}
        </TransitionGroup>
      ) : (
        <div className="newsletter-list-section__input-group">
          {newsletters}
        </div>
      )}
    </div>
  );
}

NewsletterListSection.defaultProps = {
  alreadyUsed: {},
  subscribedToIds: [],
  filter: true,
  transition: true,
  handleNewslettersRadioUpdate: () => {}
};

NewsletterListSection.propTypes = {
  subscribedToIds: PropTypes.arrayOf(PropTypes.number),
  sectionIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)])
  ).isRequired,
  masterLookup: PropTypes.shape({}).isRequired,
  state: PropTypes.shape({}).isRequired,
  alreadyUsed: PropTypes.shape({}),
  sectionTitle: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  transition: PropTypes.bool,
  filter: PropTypes.bool,
  handleNewslettersRadioUpdate: PropTypes.func
};

export default NewsletterListSection;
